import type { $Fetch } from 'ofetch';
import type {
  CobrancaReguaPasso, UpsertCobrancaReguaPassoCommand, RunReguaResult,
} from '@/domain/model/CobrancaRegua';
import type { CobrancaReguaGateway } from '@/application/port/out/CobrancaReguaGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/cobranca/regua/passos';

export class HttpCobrancaReguaGateway implements CobrancaReguaGateway {
  constructor(private readonly client: $Fetch) {}

  async list(): Promise<CobrancaReguaPasso[]> {
    const res = await this.client<ApiResponse<CobrancaReguaPasso[]>>(PATH, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertCobrancaReguaPassoCommand): Promise<CobrancaReguaPasso> {
    const res = await this.client<ApiResponse<CobrancaReguaPasso>>(PATH, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertCobrancaReguaPassoCommand): Promise<CobrancaReguaPasso> {
    const res = await this.client<ApiResponse<CobrancaReguaPasso>>(
      `${PATH}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async delete(id: string): Promise<void> {
    const res = await this.client<ApiResponse<void>>(
      `${PATH}/${encodeURIComponent(id)}`, { method: 'DELETE' },
    );
    assertApiSuccess(res);
  }

  async run(): Promise<RunReguaResult> {
    const res = await this.client<ApiResponse<RunReguaResult>>(
      `${PATH}/run`, { method: 'POST' },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
